import { AppSettingContext } from "@src/components/Application";
import React, { useEffect, useRef, useState } from "react";
import { ISenderDetails } from "../../../models/SenderDetails.model";
import LabeledCheckbox from "../../atoms/LabeledCheckbox";
import { hasXSSCharacters, isEmail } from "../../../helpers/Utils";

interface IRecipientsStepSenderDetailsProps {
    //model: IRecipientsStep;
    sender: ISenderDetails;
    hasToShowSameAsRecipientToggle: boolean;
    senderSameAsRecipient: boolean;
    handleSenderSameAsRecipientChange(checked: boolean): void;
    handleModelUpdate(sender: ISenderDetails): void;
}

const RecipientsStepSenderDetails = (props: IRecipientsStepSenderDetailsProps) => {
    const ref = useRef(true);

    //Page translation
    const { labels } = React.useContext(AppSettingContext);

    const [firstName, setFirstName] = useState(props.sender.firstName || "");
    const [lastName, setLastName] = useState(props.sender.lastName || "");
    const [email, setEmail] = useState(props.sender.email || "");
    const [phone, setPhone] = useState(props.sender.phone || "");
    const [company, setCompany] = useState(props.sender.company || "");

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const firstRender = useRef(true);

    useEffect(() => {
        const firstRender = ref.current;
        if (firstRender) {
            ref.current = false;
        }

    }, [])

    useEffect(() => {
        const firstRender = ref.current;
        if (firstRender == false) {
            propagateChanges();
        }
    }, [firstName, lastName, email, company]);

    const propagateChanges = () => {
        if (firstRender.current) {
            props.handleModelUpdate({
                firstName: firstName,
                firstNameIsValid: true,
                lastName: lastName,
                lastNameIsValid: true,
                email: email,
                emailIsValid: true,
                phone: phone,
                company: company
            } as ISenderDetails);

            //because this function is being called multiple times, wait 0.1 seconds before setting the firstRender to false
            setTimeout(() => {
                firstRender.current = false;
            }, 100);

            return;
        }

        props.handleModelUpdate({
            firstName: firstName,
            firstNameIsValid: props.sender.firstNameIsValid,
            lastName: lastName,
            lastNameIsValid: props.sender.lastNameIsValid,
            email: email,
            emailIsValid: props.sender.emailIsValid,
            phone: phone,
            company: company
        } as ISenderDetails);
    };

    if (error) throw error;
    return (
        <div className="who-is-it-from">
            <hr />
            <div className="wiif__details">
                <h5>{labels.get("GiftCard.App.Steps.Recepients.Fields.Sender.Title")}</h5>

                {/*show only of there are only 1 recipient*/}
                {props.hasToShowSameAsRecipientToggle &&
                    <div className="form-field">
                        <LabeledCheckbox id="wiif__same_as_recipient" cssClass=""
                            checked={props.senderSameAsRecipient}
                            onChange={(result) => props.handleSenderSameAsRecipientChange(result)}
                            labelCssClass="label-fs"
                            lableTitle={labels.get("GiftCard.App.Steps.Recepients.Fields.Sender.SameAsRecipient")}
                        />
                    </div>}
            </div>

            <div className="flex-container">
                <div className="form-field" style={{ flex: '1 1 48%' }}>
                    <label htmlFor="wiif__first-name">{labels.get("GiftCard.App.Steps.Recepients.Fields.SenderFirstName.Label")}</label>
                    <input type="text" name="wiif__first-name" id="wiif__first-name" placeholder={labels.get("GiftCard.App.Steps.Recepients.Fields.SenderFirstName.Placeholder")}
                        value={firstName}
                        maxLength={150}
                        onChange={event => {
                            if (hasXSSCharacters(event.target.value)) {
                                event.preventDefault();
                            } else {
                                if (!event.target.value.trim()) {
                                    props.sender.firstNameIsValid = false;
                                } else {
                                    props.sender.firstNameIsValid = true;
                                }

                                setFirstName(event.target.value);
                            }
                        }}
                        className={props.sender.firstNameIsValid === false ? "react-input-error" : ""}
                    />
                    {props.sender.firstNameIsValid === false &&
                        <div className="react-input-error-message">
                            Please enter sender first name
                        </div>
                    }
                </div>
                <div className="form-field" style={{ flex: '1 1 48%' }}>
                    <label htmlFor="wiif__last-name">{labels.get("GiftCard.App.Steps.Recepients.Fields.SenderLastName.Label")}</label>
                    <input type="text" name="wiif__last-name" id="wiif__last-name" placeholder={labels.get("GiftCard.App.Steps.Recepients.Fields.SenderLastName.Placeholder")}
                        value={lastName}
                        maxLength={150}
                        onChange={event => {
                            if (hasXSSCharacters(event.target.value)) {
                                event.preventDefault();
                            } else {
                                if (!event.target.value.trim()) {
                                    props.sender.lastNameIsValid = false;
                                } else {
                                    props.sender.lastNameIsValid = true;
                                }

                                setLastName(event.target.value);
                            }
                        }}
                        className={props.sender.lastNameIsValid === false ? "react-input-error" : ""}
                    />
                    {props.sender.lastNameIsValid === false &&
                        <div className="react-input-error-message">
                            Please enter sender last name
                        </div>
                    }
                </div>
                <div className="form-field full__width">
                    <label htmlFor="wiif__email">{labels.get("GiftCard.App.Steps.Recepients.Fields.SenderEmail.Label")}</label>
                    <input type="text" name="wiif__email" id="wiif__email" placeholder={labels.get("GiftCard.App.Steps.Recepients.Fields.SenderEmail.Placeholder")}
                        value={email}
                        maxLength={150}
                        onChange={event => {
                            if (hasXSSCharacters(event.target.value)) {
                                event.preventDefault();
                            } else {
                                if (!isEmail(event.target.value)) {
                                    props.sender.emailIsValid = false;
                                } else {
                                    props.sender.emailIsValid = true;
                                }

                                setEmail(event.target.value);
                            }
                        }}
                        className={props.sender.emailIsValid === false ? "react-input-error" : ""}
                    />
                    {props.sender.emailIsValid === false &&
                        <div className="react-input-error-message">
                            Please enter sender email address
                        </div>
                    }
                </div>

                <div className="form-field full__width">
                    <label htmlFor="wiif__company">{labels.get("GiftCard.App.Steps.Recepients.Fields.SenderCompany.Label")}</label>
                    <input type="text" name="wiif__company" id="wiif__company" placeholder={labels.get("GiftCard.App.Steps.Recepients.Fields.SenderCompany.Placeholder")}
                        value={company}
                        maxLength={150}
                        onChange={event => {
                            if (hasXSSCharacters(event.target.value)) {
                                event.preventDefault();
                            } else {
                                setCompany(event.target.value);
                            }
                        }}
                    />
                </div>
            </div>

        </div>
    )
}

export default RecipientsStepSenderDetails;